import script from "./NewInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NewInput.vue?vue&type=script&setup=true&lang=js"

import "./NewInput.vue?vue&type=style&index=0&id=8d981dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d981dee"]])

export default __exports__